import { setTaskName } from '../threading';
export function run(firstArg, runner) {
    let task;
    if (typeof firstArg === 'string') {
        task = runner();
        setTaskName(task, firstArg);
    }
    else {
        task = firstArg();
        setTaskName(task, task);
    }
    return task;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicnVuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Zsb3cvcnVuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBQyxXQUFXLEVBQWtCLE1BQU0sY0FBYyxDQUFDO0FBZ0QxRCxNQUFNLFVBQVUsR0FBRyxDQUNqQixRQUEwQyxFQUMxQyxNQUE4QjtJQUU5QixJQUFJLElBQUksQ0FBQztJQUNULElBQUksT0FBTyxRQUFRLEtBQUssUUFBUSxFQUFFLENBQUM7UUFDakMsSUFBSSxHQUFHLE1BQU8sRUFBRSxDQUFDO1FBQ2pCLFdBQVcsQ0FBQyxJQUFJLEVBQUUsUUFBUSxDQUFDLENBQUM7SUFDOUIsQ0FBQztTQUFNLENBQUM7UUFDTixJQUFJLEdBQUcsUUFBUSxFQUFFLENBQUM7UUFDbEIsV0FBVyxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztJQUMxQixDQUFDO0lBRUQsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDIn0=